import api from './api';

export interface QuizRecommendation {
  id: number;
  student: number;
  student_name: string;
  created_by: number;
  sessions_per_day: number;
  start_date: string;
  end_date: string;
  quiz_sessions: number[];
  quiz_sessions_detail: { id: number; name: string }[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface TeacherControlSettings {
  controlled_by: 'teacher' | 'parent';
  min_quizzes_per_day: number;
  time_slots: {
    id?: number;
    label: string;
    start_time: string;
    end_time: string;
    max_quizzes: number;
    order: number;
  }[];
}

class QuizRecommendationService {
  async getAll(studentId?: number): Promise<QuizRecommendation[]> {
    const params = studentId ? `?student=${studentId}` : '';
    const response = await api.get(`/quiz-recommendations/${params}`);
    return response.data.results || response.data;
  }

  async create(data: {
    student: number;
    sessions_per_day: number;
    start_date: string;
    end_date: string;
    quiz_sessions?: number[];
  }): Promise<QuizRecommendation> {
    const response = await api.post('/quiz-recommendations/', data);
    return response.data;
  }

  async update(id: number, data: Partial<{
    sessions_per_day: number;
    start_date: string;
    end_date: string;
    is_active: boolean;
    quiz_sessions: number[];
  }>): Promise<QuizRecommendation> {
    const response = await api.patch(`/quiz-recommendations/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/quiz-recommendations/${id}/`);
  }

  async getTeacherControl(studentId: number): Promise<TeacherControlSettings> {
    const response = await api.get(`/quiz-sessions/teacher-control/?student=${studentId}`);
    return response.data;
  }

  async updateTeacherControl(studentId: number, data: Partial<TeacherControlSettings>): Promise<void> {
    await api.put(`/quiz-sessions/teacher-control/?student=${studentId}`, data);
  }
}

export default new QuizRecommendationService();
